import variables from '../variables';

const MuiOutlinedInput = {
  styleOverrides: {
    root: {
      fontSize: variables.input.fontSize,
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: variables.input.borderColorHover,
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderWidth: variables.input.borderWidth,
      },
    },
    input: {
      paddingTop: 8,
      paddingBottom: 8,
      borderColor: variables.input.borderColor,
      backgroundColor: variables.input.backgroundColor,
      '&.Mui-disabled': {
        border: `1px solid ${variables.colors.lightGrey}`,
        background: variables.colors.lightGrey,
        cursor: 'not-allowed',
      },
    },
    notchedOutline: {
      borderWidth: variables.input.borderWidth,
      borderColor: variables.input.borderColor,
    },
  },
};

export default MuiOutlinedInput;
